import Image from 'next/image';

import hassleFreeProcess from '@/assets/images/hassleFreeProcess.svg';
import secureShield from '@/assets/images/secureShield.svg';
import withDrawCash from '@/assets/images/withDrawCash.svg';
import worldwideAcceptance from '@/assets/images/worldwideAcceptance.svg';

const CardReason = () => {
  return (
    <section className="home__tab">
      <div className="reason-tab-content bg bg--light">
        <div className="tab-pane active container">
          <h2 className="text--black text--bold section__title-small step-text text-center">
            Reasons to Choose Forex Card with Us
          </h2>
          <div className="row">
            <div className="col-lg">
              <div className="tab__card__container">
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={secureShield}
                      alt="30 minutes door step service"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">100%</span> Secure
                      transactions
                    </p>
                  </div>
                </div>
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={hassleFreeProcess}
                      alt="lowest interest rate"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">Hassle-free</span> <br />{' '}
                      process
                    </p>
                  </div>
                </div>
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={worldwideAcceptance}
                      alt="lowest interest rate"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">Worldwide</span> acceptance
                    </p>
                  </div>
                </div>
                <div className="item reason_item">
                  <div className="tab__card reason-tab_card">
                    <Image
                      style={{ color: undefined }}
                      className="img-fluid"
                      src={withDrawCash}
                      alt="gold rate"
                    />
                    <p className="text--black text--regular title text-center">
                      <span className="text--bold">Withdraw cash</span> anytime,
                      anywhere
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default CardReason;
